query getMarketDaily($market_id: [String]!) {
    getMarketDaily(market_id: $market_id) 
}
